import { Layers, ListChecks, ShieldCheck, UploadCloud, Workflow, FileClock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const FEATURES = [
  { key: 'multiCompetition', icon: Layers },
  { key: 'dynamicForms', icon: ListChecks },
  { key: 'fileVersioning', icon: UploadCloud },
  { key: 'rubricJudging', icon: ShieldCheck },
  { key: 'lifecycle', icon: Workflow },
  { key: 'resultsAudit', icon: FileClock },
] as const

/** Platform capability summary. Every entry maps to a real, shipped area of the app. */
export function FeatureSection() {
  const { t } = useTranslation('home')

  return (
    <section className="flex flex-col gap-4 pt-1 pb-4 md:pt-2 md:pb-6">
      <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">{t('features.heading')}</h2>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map(({ key, icon: Icon }) => (
          <div key={key} className="flex flex-col gap-3">
            <Icon className="size-8 text-primary" aria-hidden="true" />
            <h3 className="text-xl font-medium">{t(`features.${key}.title`)}</h3>
            <p className="text-lg text-muted-foreground">{t(`features.${key}.description`)}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
